
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {useRecoilState} from "recoil";
import {activeAutom} from "../../../../recoil-store/recoil-state";
import {getExtension} from "../../../../helpers/helper";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import {Button} from "@material-ui/core";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function PostPagination() {

    return (
        <></>
    )
}

export default PostPagination;